module.exports = __webpack_public_path__ + "static/media/no_posts.6dcf192c.png";